<div class="shadow-sm p-4 mb-5 bg-white rounded">
  <ng-content></ng-content>
</div>
